import ENV from "config/Env";
import { backendQueryKey, permanentBackendQueryKey } from "hooks";

import type { FactoryExport, FactoryExportReceiver, FactoryReport } from "models";

const component = "FactoryExportsDashboard";

export const FactoryExportsDashboardQueryKeys = {
  exports: backendQueryKey<FactoryExport[]>({ component, baseUrl: ENV.reportsBaseURL, endpoint: "/exports/list_exports" }),
  receivers: backendQueryKey<FactoryExportReceiver[]>({ component, baseUrl: ENV.reportsBaseURL, endpoint: "/exports/list_receivers" }),
  reports: permanentBackendQueryKey<FactoryReport[]>({ component, baseUrl: ENV.reportsBaseURL, endpoint: "/exports/list_reports" })
};
